export const siteSettings = {
  name: "Legacy Finance Ltd",
  link: "https://legacyfinanceltd.com",
  email: "support@legacyfinanceltd.com",
  appLink: "https://app.legacyfinanceltd.com",
};
